import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import ClapprPlayer from '/components/Clappr/ClapprPlayer';
import {
    isMobile
  } from "react-device-detect";
  
const styles = theme => ({

})
class IntroVideo extends React.Component{
    constructor(props){
        super(props);
        this.state = {
           ssrDone: false,
        };   
      }  
    render(){
        const { classes } = this.props;
        const ssrDone = this.state.ssrDone; 
        const videoAboutUs = {
          "title": "Duwun - The biggest online media in Myanmar within two years",
          "posters": {
            "social": "https://duwun.sgp1.cdn.digitaloceanspaces.com/145091/conversions/duwun-about-us-video-poster-social.jpg",
            "thumb": "https://duwun.sgp1.cdn.digitaloceanspaces.com/145091/conversions/duwun-about-us-video-poster-thumb.jpg",
            "thumb_mobile": "https://duwun.sgp1.cdn.digitaloceanspaces.com/145091/conversions/duwun-about-us-video-poster-thumb_mobile.jpg",
            "next_video_teaser": "https://duwun.sgp1.cdn.digitaloceanspaces.com/145091/conversions/duwun-about-us-video-poster-next_video_teaser.jpg",
            "mobile_next_video_teaser": "https://duwun.sgp1.cdn.digitaloceanspaces.com/145091/conversions/duwun-about-us-video-poster-mobile_next_video_teaser.jpg",
            "video_section_teaser": "https://duwun.sgp1.cdn.digitaloceanspaces.com/145091/conversions/duwun-about-us-video-poster-video_section_teaser.jpg",
            "mobile_video_section_teaser": "https://duwun.sgp1.cdn.digitaloceanspaces.com/145091/conversions/duwun-about-us-video-poster-mobile_video_section_teaser.jpg"
          },
          "slug": "duwun-the-biggest-online-media-in-myanmar-within-two-yearsmp4-id892",
          "description": "<div>Duwun started in December 2015 as a young media start-up backed by Ringier and Information Matrix. We came to the media space with millennial focused lifestyle and entertainment coverage which got strong supports from Myanmar millennials.<br><br>Duwun reached 1 million social followers within first six months and kept growing at an exponential rate. The next million only took 2 months.<br><br>By early 2017, the trend changed. Our millennials don't want to read long text anymore. They want interactivity. So we launched Duwun TV to keep the milleniels happy with cool video content.<br><br>Later on, we started expanding our reach by launching more community focus pages such as Duwun Sports for sports, Cele Yatkwat for celebrity, Duwun Tech for startups and disruptive tech, Madi for women empowerment and Ayathar for Foodie culture creating much quicker and more in-depth coverage.<br><br>Now Duwun stands at a total of 10 million combined social media followers generating 13 million pageviews a month and 50 million video views a month making us the No.1 online media in Myanmar in terms of readership.<br><br>We love your support and we will keep growing further.</div>",
          "p_date": "2017-05-30T23:28:47Z",
          "duration": "83",
          "jwplayer": true,
          "jwplayer_id": "6WEvvopZ",
          "video_url": "https://dmbf27t3xv7sf.cloudfront.net/converted/nxwYeVSZ9V/549.m3u8",
          "jw_media_id": "mI0US4qb",
          "media_id": "nxwYeVSZ9V",
          "published_date": {
            "date": "2017-05-30T23:28:47Z"
          },
          "author": {
            "name": "Ko Aung",
            "email": "aungmyo.linn@duwun.com.mm"
          },
          "created_at": {
            "date": "2020-04-12 23:27:40.000000",
            "timezone_type": 3,
            "timezone": "UTC"
          },
          "updated_at": {
            "date": "2020-04-12 23:33:05.000000",
            "timezone_type": 3,
            "timezone": "UTC"
          },
          "tags": [],
          "categories": [],
          "visitors": 1,
          "ga": {
          "ga:pageviews": "0"
          },
          "ad_tag": null,
          "no_ads": false
        }
        return(
            ssrDone &&
                            
            <div className={classes.videoWrapper}>
                <ClapprPlayer
                    id="duwun-advertise-with-us-clappr-player"
                    width="100%"
                    height={isMobile ? "calc(100vw * 0.5625)" : "90vh"}
                    autoPlay
                    poster={videoAboutUs.posters.thumb}
                    source={videoAboutUs.video_url}
                    video={videoAboutUs}
                    controls={false}
                />            
            </div>
              
        )
    }
    componentDidMount(){
        this.setState({
            ssrDone: true,
        });
    }
}
export default withStyles(styles)(IntroVideo);